<template>
  <div>
    <!--<LoadingModal></LoadingModal>-->
    <!--
    <button @click="selectBetgame" class="bg-black text-white p-2 rounded">
      Los geht's!
    </button>
    -->
  </div>
</template>

<script>
import Vue from 'vue'
import LoadingModal from '@/components/LoadingModal.vue'
import {
  BATTLE_COMPETITION, TOAST_DURATION,
  TYPE_BATTLE,
  TYPE_BATTLE_ID,
  TYPE_BETGAME,
  TYPE_BETGAME_ID,
  TYPE_TEAMS,
  TYPE_TEAMS_ID
} from '@/main'
import jwt_decode from 'jwt-decode'
import moment from 'moment/moment'
import Numeral from 'numeral'

export default {
  name: "AppleOAuth",
  components: { LoadingModal },
  created() {

  },
  mounted() {
    const id = this.$route.query.fk_user
    const eid = this.$route.query.external_id
    const elogin = this.$route.query.external_login
    const email = this.$route.query.email
    const msg = this.$route.query.msg
    const pwd = eid.slice(1, -1)
    if(msg && msg === 'email_already_used') {
      var r = confirm(this.$i18n.t('register.change_login_type', {email: email, type: 'Apple'}))
      if (r === true) {
        window.localStorage.setItem('betgameAction', '')
        this.$store.dispatch('resetExternalLogin', {
          userid: id,
          email: email,
          pass: pwd,
          external_id: eid,
          external_login: elogin
        }).then(() => {
          //this.$router.push({ name: 'dashboard' })
          window.location.href = 'https://teamtip.net/feed/dashboard'
        }).catch(function (error) {
          Vue.$toast.open({ message: error.toString(), position: 'top', duration: 2 * TOAST_DURATION, type: 'error' })
        })
      } else {
        window.localStorage.setItem('betgameAction', '')
        window.location.href = 'https://teamtip.net/login'
      }
    } else {
      this.$store.dispatch('login', {
        email: String(email).toLowerCase(),
        pass: pwd
      }).then((res) => {
        const bgid = this.getBGValue('spmbgid')
        const ic = this.getBGValue('spmic')
        if (ic !== undefined && ic !== null && this.isNumeric(ic) && ic > 0) {
          window.localStorage.setItem('spmic', '')
          this.$store.dispatch('patchUser', {
            source: ic
          })
        } else {
          const us = window.localStorage.getItem('userSource') || ''
          if(us !== undefined && us !== null && us !== '') {
            this.$store.dispatch('patchUser', {
              source: us
            })
          }
        }
        const betgameAction = this.getBGValue('betgameAction')
        if (betgameAction && betgameAction === 'invitation' && bgid !== undefined && bgid !== null && this.isNumeric(bgid) && bgid > 0) {
          window.localStorage.setItem('betgameAction', '')
          this.$store.dispatch('userEnterBetgame', bgid).then(() => {
            this.$router.push('/feed/dashboard')
          })
        } else if (betgameAction && betgameAction === 'login') {
          window.localStorage.setItem('betgameAction', '')
          if (bgid !== undefined && bgid !== null && this.isNumeric(bgid) && bgid > 0) {
            this.$store.dispatch('userEnterBetgame', bgid).then(() => {
              this.$router.push('/feed/dashboard')
            })
          } else {
            window.location.href = 'https://teamtip.net/?clr=1' 
          }
        } else if (betgameAction && betgameAction === 'registerUserCreateBetgame') {
          window.localStorage.setItem('betgameAction', '')
          const c = window.localStorage.getItem('createBetgame')
          const createBetgame = JSON.parse(c)
          this.$store.dispatch('createBetgame', {
            email: email,
            user_id: '' + id,
            betgame: createBetgame.betgameName.trim(),
            competition: createBetgame.betgameType === TYPE_BETGAME ? parseInt(createBetgame.competition) : BATTLE_COMPETITION
          })
          .then(() => {
            this.$store.dispatch('patchBetgame', {
              bet_mode: createBetgame.betmode,
              description: createBetgame.betgameDescription,
              type: createBetgame.betgameType === 'battle' ? TYPE_BATTLE_ID : (createBetgame.betgameType === 'teams' ? TYPE_TEAMS_ID : TYPE_BETGAME_ID)
            }).then(() => {
            })
            this.$store.dispatch('addBetgamesOwner', {
              id: this.$store.state.betgameId,
              name: 'Neue Tipprunde',
              type: 'Wettbewerb'
            })
            if (this.$store.state.chat_token && this.$store.state.chat_token !== '') {
              const payload = jwt_decode(JSON.stringify(this.$store.state.chat_token))
              const a = payload.exp * 1000
              const b = moment()
              if (a > b) {
                this.$store.dispatch('chatCreateConversation', {
                  'title': createBetgame.betgameName.trim(),
                  'participant_ids': ['' + id]
                }).then(response => {

                })
                .catch(function(error) {

                })
              }
            }
            if (createBetgame.betgameType === TYPE_BATTLE) {
              const sm = createBetgame.selectedMatches
              var m = []
              for (var key in sm) {
                if (sm.hasOwnProperty(key)) {
                  for (var key1 in sm[key]) {
                    if (sm[key].hasOwnProperty(key1)) {
                      const v = sm[key][key1]
                      if (v === true) {
                        m.push({ fk_betgame: this.$store.state.betgameId, fk_match: parseInt(key1) })
                      }
                    }
                  }
                }
              }
              const data = {
                fk_betgame: this.$store.state.betgameId,
                matches: m
              }
              this.$store.dispatch('saveBetgameMatches', data).then(response => {
                if (response.status >= 200 && response.status <= 204) {
                  this.$store.dispatch('clearSelectedMatches', {}).then(() => {
                  })
                }
              }, error => {

              })
            } else if (createBetgame.betgameType === TYPE_TEAMS) {
              const sc = createBetgame.selectedCompetitions
              const stc = createBetgame.selectedTeamsCompetitions
              const data = []
              for (var i = 0; i < sc.length; i++) {
                const t = stc.filter(x => x.bg_competition.id === sc[i])
                if (t) {
                  for (var j = 0; j < t.length; j++) {
                    const d = {
                      fk_team: parseInt(t[j].bg_team.id),
                      fk_season: parseInt(this.$store.state.currentSeason.id),
                      fk_competition: parseInt(sc[i]),
                      fk_betgame: this.$store.state.betgameId
                    }
                    data.push(d)
                  }
                }
              }
              this.$store.dispatch('saveBetgameTeamCompetitions', data).then(response => {
                if (response.status >= 200 && response.status <= 204) {
                  this.$store.dispatch('clearSelectedTeams', {}).then(() => {
                    this.$store.dispatch('clearSelectedTeamsCompetitions', {}).then(() => {
                      this.$store.dispatch('clearSelectedCompetitions', {}).then(() => {
                      })
                    })
                  })
                }
              }, error => {
              })
            }
            this.$store.dispatch('switchBetgame', this.$store.state.betgameId).then(() => {
              //this.$store.dispatch('fetchBetgame', this.$store.state.betgameId).then(() => {
              this.$router.push('/betgameedit')
              //})
            })
          }).catch(function(error) {
            alert(this.$t('errors.betgame_save_failed') + ' ' + error.toString())
          })
        }
      })
    }
  },
  methods: {
    selectBetgame(selectedBetgame) {
      window.location.href = 'https://teamtip.net/?clr=1'
    },
    signInWithApple() {
      const clientId = 'net.teamtip.app'; // Deine Service-ID von Apple
      const redirectURI = 'https://teamtip.net/auth/apple'; // Backend Redirect

      const url = `https://appleid.apple.com/auth/authorize?` +
        `response_type=code%20id_token` +
        `&client_id=${encodeURIComponent(clientId)}` +
        `&redirect_uri=${encodeURIComponent(redirectURI)}` +
        `&scope=name%20email` +
        `&response_mode=form_post`;

      window.location.href = url;
    }
  }
};
</script>
